<ng-container *transloco="let t">
  @let activeLang = activeLang$ | async;
  @let readOnly = readOnly$ | async;
  @let isInFormBuilder = isInEditQuestionMode() || isInFormBuilderMode();
  @let showDirektsignering = isEnPartsProjekt() || isInFormBuilder;
  @let signeringServiceError = signeringServiceError$ | async;
  @let isLoadingSigneringService = isLoadingSigneringService$ | async;

  <div class="question-signering-container">
    <!-- #region MVP Komponent -->
    @if (
      isEnPartsProjekt() && (fileList.length === 0 || !isFileUploadedSuccess())
    ) {
      <lib-input-container
        [headLine]="
          translations[questionStructureName.HeadLine]
            | translate: activeLang : structure[questionStructureName.HeadLine]
        "
        [required]="true"
        [hideAbove]="true"
        [hideBelow]="true"
      >
        <div
          class="question-signering-description"
          [innerHTML]="
            translations[questionStructureName.Description]
              | translate
                : activeLang
                : structure[questionStructureName.Description]
          "
        ></div>

        <!-- #region DirektSignering Accordion -->
        @if (showDirektsignering && isMVP()) {
          @let direktSignering =
            {
              Title: questionStructureName.Signering.DirektSignering.Title,
              Intro: questionStructureName.Signering.DirektSignering.Intro,
              Description:
                questionStructureName.Signering.DirektSignering.Description,
            };
          <div class="signering-card-container">
            <lib-accordion-card
              [title]="
                translations[direktSignering.Title]
                  | translate: activeLang : structure[direktSignering.Title]
              "
              [subtitle]="
                translations[direktSignering.Intro]
                  | translate: activeLang : structure[direktSignering.Intro]
              "
              [isOpen]="
                (isMVP() && direktSigneringIsOpen()) ||
                (isInFormBuilderMode() && direktSigneringIsOpen()) ||
                isInEditQuestionMode()
              "
              [isCollapsable]="!direktSigneringIsOpen()"
              [toggleCollapseOnClick]="false"
              (click)="openSignering(SigneringTypeEnum.DirektSignering)"
            >
              <div
                class="question-signering-description"
                [innerHTML]="
                  translations[direktSignering.Description]
                    | translate
                      : activeLang
                      : structure[direktSignering.Description]
                "
              ></div>
              @if (
                signeringServiceError.includes(
                  SigneringServiceErrorEnum.DirektsigneringNotAvailable
                )
              ) {
                <div class="error-message-container">
                  <span class="error-message">
                    <lib-icon
                      name="x-circle"
                      class="failed-icon"
                      size="small"
                    ></lib-icon>
                    {{ t('question_signering_service_not_responding') }}
                  </span>
                </div>
              }
              @if (isLoadingSigneringService) {
                <div class="loader-container">
                  <div class="loader loading-indicator"></div>
                </div>
              }
              @if (!isLoadingSigneringService) {
                <div class="direkt-signering-button-container">
                  <button
                    vinnova-button-primary
                    [disabled]="readOnly !== ReadonlyState.Editable"
                    (click)="goToSignering()"
                  >
                    {{ t('question_signering_to_signing') }}
                    <lib-icon name="external-link" />
                  </button>
                </div>
              }
            </lib-accordion-card>
          </div>
        }
        <!-- #endregion DirektSignering Accordion -->

        <!-- #region ManuellSigering Accordion -->
        <div class="signering-card-container">
          @let manuellSignering =
            {
              Title: questionStructureName.Signering.ManuellSignering.Title,
              Intro: questionStructureName.Signering.ManuellSignering.Intro,
              Description:
                questionStructureName.Signering.ManuellSignering.Description,
            };
          <lib-accordion-card
            [title]="
              isMVP()
                ? (translations[manuellSignering.Title]
                  | translate: activeLang : structure[manuellSignering.Title])
                : null
            "
            [subtitle]="
              isMVP()
                ? (translations[manuellSignering.Intro]
                  | translate: activeLang : structure[manuellSignering.Intro])
                : null
            "
            [isOpen]="manuellSigneringIsOpen() || isInEditQuestionMode()"
            [isCollapsable]="!manuellSigneringIsOpen()"
            [isAlwaysOpen]="!isMVP()"
            [hideBorder]="!isMVP()"
            [toggleCollapseOnClick]="false"
            (click)="openSignering(SigneringTypeEnum.ManuellSignering)"
          >
            <div class="manuell-signering-container">
              <div
                class="question-signering-description"
                [innerHTML]="
                  translations[manuellSignering.Description]
                    | translate
                      : activeLang
                      : structure[manuellSignering.Description]
                "
              ></div>
              <lib-file-upload
                [id]="labelPrefix() + question().id"
                [disabled]="
                  isUploadDisabled || (!!readOnly && fileList.length === 0)
                "
                [error]="
                  (readOnly !== ReadonlyState.Reader && isInvalid()) ||
                  (readOnly === ReadonlyState.Locked &&
                    fileList.length === 0 &&
                    question().validation.required) ||
                  error()
                "
                [readonly]="readOnly"
                [uploadedFiles]="fileList"
                [required]="required"
                [allowedFileTypes]="allowedFileTypes()"
                [maxNumberOfFiles]="maxNumberOfFiles"
                [maxNumberOfPages]="maxNumberOfPages"
                [isUpdatingAnswer]="rendererFormRepository.isLoading$ | async"
                [maxFileSize]="maxFileSize"
                (upload)="uploadFiles($event)"
                (download)="downloadFile($event)"
                (remove)="removeFile($event)"
              ></lib-file-upload>
            </div>
          </lib-accordion-card>
        </div>
        <!-- #endregion ManuellSigering Accordion -->
      </lib-input-container>
    }

    <!-- #region MVP Komponent: Uploaded files list container-->
    @if (isEnPartsProjekt() && fileList.length > 0 && isFileUploadedSuccess()) {
      <div class="uploaded-files-container">
        <span>{{ t('question_signering_approved_participation') }}</span>
        <div class="uploaded-file-list-container">
          <span class="uploaded-file-title">
            @if (isDigitaltSignerad) {
              {{ t('question_signering_digitally_signed_approval') }}
            } @else {
              {{ t('question_signering_signed_approval_form') }}
            }
          </span>
          <div class="uploaded-files-list">
            @for (file of fileList; track file.pdfFileName) {
              <ng-container
                *ngTemplateOutlet="
                  uploadedFile;
                  context: { file: file, transloco: t }
                "
              ></ng-container>
            }
          </div>
        </div>
      </div>
    }
    <!-- #endregion MVP Komponent: Uploaded files list container-->
    <!-- #endregion MVP Komponent -->

    <!-- #region Non-MVP Komponent -->
    @if (!isEnPartsProjekt()) {
      <lib-input-container
        [headLine]="
          translations[questionStructureName.HeadLine]
            | translate: activeLang : structure[questionStructureName.HeadLine]
        "
        [required]="true"
        [hideAbove]="true"
        [hideBelow]="true"
      >
        <div
          class="question-signering-description"
          [innerHTML]="
            translations[questionStructureName.Description]
              | translate
                : activeLang
                : structure[questionStructureName.Description]
          "
        ></div>

        <!-- #region Non-MVP PPG Upload Accordion -->
        <div class="signering-card-container">
          @let manuellSignering =
            {
              Title: questionStructureName.Signering.ManuellSignering.Title,
              Intro: questionStructureName.Signering.ManuellSignering.Intro,
              Description:
                questionStructureName.Signering.FlerpartsSignering.Description,
            };
          <lib-accordion-card
            [isOpen]="manuellSigneringIsOpen() || isInEditQuestionMode()"
            [isCollapsable]="!manuellSigneringIsOpen()"
            [isAlwaysOpen]="!isMVP()"
            [hideBorder]="!isMVP()"
            [toggleCollapseOnClick]="false"
            (click)="openSignering(SigneringTypeEnum.ManuellSignering)"
          >
            <div class="manuell-signering-container">
              <div
                class="question-signering-description"
                [innerHTML]="
                  translations[manuellSignering.Description]
                    | translate
                      : activeLang
                      : structure[manuellSignering.Description]
                "
              ></div>
              @if ((readOnly && fileList.length === 0) || !readOnly) {
                <lib-file-upload
                  [id]="labelPrefix() + question().id"
                  [disabled]="isUploadDisabled || !!readOnly"
                  [error]="
                    (readOnly !== ReadonlyState.Reader && isInvalid()) ||
                    (readOnly === ReadonlyState.Locked &&
                      fileList.length === 0 &&
                      question().validation.required) ||
                    error()
                  "
                  [readonly]="readOnly"
                  [uploadedFiles]="fileList"
                  [required]="required"
                  [allowedFileTypes]="allowedFileTypes()"
                  [maxNumberOfFiles]="maxNumberOfFiles"
                  [maxNumberOfPages]="maxNumberOfPages"
                  [maxFileSize]="maxFileSize"
                  (upload)="uploadFiles($event)"
                  (download)="downloadFile($event)"
                  (remove)="removeFile($event)"
                ></lib-file-upload>
              }
            </div>
          </lib-accordion-card>
        </div>
        <!-- #endregion Non-MVP PPG Upload Accordion -->
      </lib-input-container>
    }
    <!-- #region Non-MVP Komponent: Readonly file list -->
    @if (!isEnPartsProjekt() && readOnly) {
      @if (
        readOnly && question().structure.description && fileList.length > 0
      ) {
        <div class="readonly description-break-line"></div>
      }
      @for (file of valueFormControl().value; track $index) {
        <div class="readonly d-flex align-items-center">
          <button
            type="button"
            class="btn link-btn d-flex"
            (click)="downloadFile(file)"
          >
            <lib-icon name="file-text" class="description-icon"></lib-icon>
            <strong class="file-name"
              >{{
                file.pdfFileName.replace('_', '-').slice(0, -4) +
                  '-' +
                  file.originalFileName.slice(
                    0,
                    file.originalFileName.lastIndexOf('.')
                  )
              }}
            </strong>
          </button>
          <div class="file-info">
            <span
              >({{
                file.originalFileName.slice(
                  file.originalFileName.lastIndexOf('.') -
                    file.originalFileName.length +
                    1
                )
              }}</span
            >
            <span
              >,
              {{
                file.fileSize ? math.round(file?.fileSize / 1024) : '- '
              }}kB)</span
            >
          </div>
        </div>
      }
    }
    <!-- #endregion Non-MVP Komponent: Readonly file list -->
    <!-- #endregion Non-MVP Komponent -->
  </div>
</ng-container>

<ng-template #uploadedFile let-file="file" let-t="transloco">
  @let readOnly = readOnly$ | async;
  <div class="uploaded-file-list-row">
    @if (file.status === UploadedFileStatus.Uploaded) {
      <div
        class="uploaded-file-name"
        [class.success]="file.status === UploadedFileStatus.Uploaded"
      >
        @if (isDigitaltSignerad) {
          {{ file.originalFileName }}
        }
        @if (!!!isDigitaltSignerad) {
          {{ file.pdfFileName }}
          <span>
            -
            {{
              file.originalFileName.slice(
                0,
                file.originalFileName.lastIndexOf('.')
              ) +
                '.' +
                file.originalFileName.slice(
                  file.originalFileName.lastIndexOf('.') + 1
                )
            }}
          </span>
        }
      </div>
    }
    @if (file.status === UploadedFileStatus.Uploaded) {
      <lib-icon name="check-circle" class="success success-icon"></lib-icon>
    }
    @if (file.status === UploadedFileStatus.Loading) {
      <div
        class="spinner-border ms-auto d-flex align-self-center"
        role="status"
      ></div>
    }
  </div>

  <div class="uploaded-file-list-row">
    @if (file.status === UploadedFileStatus.Uploaded) {
      <div class="uploaded-file-actions">
        <button
          type="button"
          class="btn link-btn d-flex"
          (click)="downloadFile(file)"
        >
          {{ t('fileupload_download_as_pdf') }}
        </button>
        @if (readOnly === ReadonlyState.Editable) {
          <span>{{ t('fileupload_or') }}</span>
          <button
            type="button"
            class="btn link-btn d-flex"
            (click)="showRemoveSigneringModal(file)"
          >
            {{ t('list_item_remove') }}
          </button>
        }
      </div>
    }
  </div>
</ng-template>

<ng-template #removeSigneringModal *transloco="let t">
  <lib-modal
    [title]="t('question_signering_confirm_delete_approval')"
    [showPrimaryButton]="true"
    [showSecondaryButton]="true"
    [showCloseButton]="true"
    (closeModal)="cancelRemoveSignering()"
    [primaryButtonText]="t('list_item_remove')"
    (primaryButton)="confirmRemoveSignering()"
    [secondaryButtonText]="t('cancel_btn_form')"
    (secondaryButton)="cancelRemoveSignering()"
  >
    <p>
      {{ t('question_signering_confirm_delete_approval_info') }}
    </p>
  </lib-modal>
</ng-template>
